import {DatasetResponse} from '@backend';
import {OtherSensitiveData} from '@shared/labels/other-sensitive-data';
import {SensitivityLevel} from '@shared/labels/sensitivity-level';

export function datasetIsHSD(dataset: DatasetResponse): boolean {
  return dataset.sensitivity_level?.id === SensitivityLevel.HSD;
}

export function datasetHasNoOtherSensitiveData(dataset: DatasetResponse): boolean {
  return dataset.other_sensitive_data?.some(data => data.id === OtherSensitiveData.NONE);
}

export function canEnableOrganizationalAccess(dataset: DatasetResponse): boolean {
  return !datasetIsHSD(dataset) && datasetHasNoOtherSensitiveData(dataset);
}
